import {useContext} from "react";
import SiteContext from "../context";

function useSiteOptions() {
  const site = useContext(SiteContext);
  return site ? site.getOptions() : null;
}

export default useSiteOptions;
